<template>
    <div id="app">
       Not found
    </div>
</template>

<script>
   

    export default {
        name: 'app'
    };
</script>

